export const certificateList = [
  {
    course: 'Software Engineering Immersive',
    provider: 'General Assembly',
    dates: 'Completed 22/11/19',
    duration: '3 months',
    logo: 'https://coursereport-s3-production.global.ssl.fastly.net/rich/rich_files/rich_files/3423/s200/general-assembly-reviews-logo.jpg',
    certificateLink: 'https://drive.google.com/file/d/16sPTdyFNVRQXC6jkSY60Ka2gAfe2FGAm/view'
  },
  {
    course: 'JavaScript Algorithms and Data Structures',
    provider: 'freecodecamp.org',
    dates: 'Completed 23/06/19',
    duration: '300 hours',
    logo: 'https://s3.amazonaws.com/freecodecamp/freecodecamp-square-logo-large.jpg',
    certificateLink: 'https://www.freecodecamp.org/certification/paulcooke/javascript-algorithms-and-data-structures'
  },
  {
    course: 'Responsive Web Design',
    provider: 'freecodecamp.org',
    dates: 'Completed 03/02/19',
    duration: '300 hours',
    logo: 'https://s3.amazonaws.com/freecodecamp/freecodecamp-square-logo-large.jpg',
    certificateLink: 'https://www.freecodecamp.org/certification/paulcooke/responsive-web-design'
  }
]